import { combineReducers } from 'redux'
import {
	AppState,
	reducer as app,
	initialState as appInitialState,
} from './app/reducer'
import {
	AuthState,
	reducer as auth,
	initialState as authInitialState,
} from './auth/reducer'
import {
	AdminState,
	reducer as admin,
	initialState as adminInitialState,
} from './admin/reducer'
import {
	ScansState,
	reducer as scans,
	initialState as scansInitialState,
} from './scans/reducer'
import {
	QAChecksState,
	reducer as qaChecks,
	initialState as qaChecksInitialState,
} from './qaChecks/reducer'
import {
	InvoicesState,
	reducer as invoices,
	initialState as invoicesInitialState,
} from './invoices/reducer'
import {
	AccidentsState,
	reducer as accidents,
	initialState as accidentsInitialState,
} from './accidents/reducer'
import {
	EmployeesState,
	reducer as employees,
	initialState as employeesInitialState,
} from './employees/reducer'
import {
	TerminationState,
	reducer as terminations,
	initialState as terminationsInitialState,
} from './terminations/reducer'
import {
	ApplicationsState,
	reducer as applications,
	initialState as applicationsInitialState,
} from './applications/reducer'

export interface RootState {
	app: AppState
	auth: AuthState
	admin: AdminState
	scans: ScansState
	qaChecks: QAChecksState
	invoices: InvoicesState
	accidents: AccidentsState
	employees: EmployeesState
	terminations: TerminationState
	applications: ApplicationsState
}

export const rootReducer = combineReducers({
	app,
	auth,
	admin,
	scans,
	qaChecks,
	invoices,
	accidents,
	employees,
	applications,
	terminations,
})

export const initialState: RootState = {
	app: appInitialState,
	auth: authInitialState,
	admin: adminInitialState,
	scans: scansInitialState,
	qaChecks: qaChecksInitialState,
	invoices: invoicesInitialState,
	accidents: accidentsInitialState,
	employees: employeesInitialState,
	terminations: terminationsInitialState,
	applications: applicationsInitialState,
}



// WEBPACK FOOTER //
// ./src/store/rootReducer.ts